<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const props = defineProps({
  keepAlive: {
    type: Boolean,
    default: true,
  },
});

const route = useRoute();
const isFullWidth = computed(() => route.meta?.fullWidth === true);

// Routes that manage filters/pagination via query params opt out of
// query-keyed remounts, else every filter change rebuilds the page.
const routeKey = computed(() =>
  route.meta.reuseOnQueryChange ? route.path : route.fullPath
);
</script>

<template>
  <div
    class="flex flex-col w-full h-full m-0 bg-n-surface-1"
    :class="
      isFullWidth ? 'p-0 overflow-hidden' : 'pb-8 pt-4 px-6 overflow-auto'
    "
  >
    <div
      class="flex w-full h-full"
      :class="isFullWidth ? 'items-stretch' : 'items-start max-w-5xl mx-auto'"
    >
      <router-view v-slot="{ Component }">
        <keep-alive v-if="props.keepAlive">
          <component :is="Component" :key="routeKey" />
        </keep-alive>
        <component :is="Component" v-else :key="routeKey" />
      </router-view>
    </div>
  </div>
</template>
